import { queryOptions } from '@tanstack/react-query';

import { getResponse, queryParams } from '@/utils';

export const getApiV1SignpostClubs = queryOptions({
  queryKey: ['getApiV1SignpostClubs'],
  queryFn: () => getResponse('getApiV1SignpostClubs'),
});

export const getApiV1SignpostAffiliationUserId = (userId: number) => {
  return queryOptions({
    queryKey: ['getApiV1SignpostAffiliationUserId', userId],
    queryFn: () => getResponse('getApiV1SignpostAffiliationUserId', userId),
  });
};

export const getApiV1SignpostPlayers = (query?: string) => {
  return queryOptions({
    queryKey: ['getApiV1SignpostPlayers', query],
    queryFn: () => getResponse('getApiV1SignpostPlayers', queryParams({ search: query })),
  });
};
